var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsNews = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.58 0h24.108v32H.58z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#343A40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.62 14h7.534M9.62 18h7.534M3.594 25c.832 0 1.507-.895 1.507-2V8c0-.552.337-1 .753-1h15.067c.416 0 .754.448.754 1v15c0 1.105-.675 2-1.507 2H3.594zM3.594 25c-.832 0-1.507-.895-1.507-2V11"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsNews);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icons-news.261ff5b330a3c59d8e659c45876b9864.svg";